/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_LoadingInputs */

const vi_sl_detail_loading = /** @type {(inputs: Sl_Detail_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

/**

* @param {Sl_Detail_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_loading = /** @type {((inputs?: Sl_Detail_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_loading(inputs)
});